<template>
  <div>
    <div class="page-container">
      <md-app md-waterfall md-mode="fixed" style="min-height: 100vh;">
        <md-app-toolbar class="md-primary">
          <div class="d-flex order-lg-2">
              <img
                src="../assets/images/logo2.png"
                loading="lazy"
                style="height:100px;"
              />
            </div>
             <div style="margin-left: auto !important;">
            <h3 class="title">UFA Easy888</h3>
            <div style="justify-content: center; display: flex; margin-top: 8px;">
              <span style="font-size: 16px; color: yellow;">{{code}}</span>
            </div>
          </div>
          <div class="d-flex order-lg-2 ml-auto">
              <div class="dropdown">
                <a
                  href="#"
                  class="nav-link pr-0 leading-none"
                  data-toggle="dropdown"
                >
                  <span
                    class="avatar"
                    id="avatar"
                    :style="{ 'background-image': `url(${pictureUrl})` }"
                  ></span>
                </a>
              </div>
            </div>
        </md-app-toolbar>
        <md-app-content>
            <div style="marginLeft: 32px;">
                <h1 class="md-title">Shotgun System</h1>
            </div>
            <div style="width: 90%; height: 1px; background-color: #212121; margin-top: 14px; margin-left:16px"></div>
            <div class="fontnew" style="line-height:2">
            🔥 <span style="font-size: 16px; color: #FF6B35;">ทุกๆ ยอดเสียของเพื่อน</span> ผู้แนะนำจะได้รับโบนัสเข้ากระเป๋าฟรีๆเลยอีก <span style="font-size: 16px; color: #FF6B35;">5%</span> ยิ่งมีเพื่อนเยอะ ฝากเยอะ ยิ่งรับเยอะ&nbsp;<span style="font-size: 16px; color: #FF6B35;">(ตลอดชีพ)</span><br>
            </div>
            <table cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr>
                    <td align="center" style="font-family: 'Lato', sans-serif;">
                        <h2
                            style="font-size: 18px; font-weight: 700; color: #FFFFFF; margin: 0; padding: 12px 0 6px 0;">
                            Your Friends
                        </h2>
                    </td>
                </tr>
                <tr v-if="error">
                  <td><h2 style="font-size: 15px; font-weight: 500; color: #FFFFFF; margin: 0; padding: 12px 0 6px 0;color:#f43838">***{{error}}***</h2></td>
                </tr>
                <tr v-for="(item,index) in history"  :key="index">
                    <td align="center">
                        <table cellspacing="0" cellpadding="0" border="0" width="90%" style="font-family: 'Lato'; margin: 12px 0 0 0; box-shadow: 0 3px 6px #d8d8d9; border-radius: 4px; overflow: hidden;">
                            <tr>
                                <td align="left" bgcolor="#FFFFFF">
                                    <table cellspacing="0" cellpadding="0" border="0" width="100%">
                                        <tr>
                                            <td align="left" bgcolor="#FFFFFF" width="50" style="padding: 2px 2px 2px 2px; color: #7E7E7E;">
                                                <img :src="item.image" alt="" style="border-radius:50%;">
                                            </td>
                                            <td align="left" bgcolor="#FFFFFF" width="150" style="padding-left: 5px;font-family: 'Lato';">
                                                <p style="font-size: 14px; color: #050505; font-weight:850; margin:0;">{{item.code}}&nbsp;<span v-if="item.mine">🥳</span></p>
                                            </td>
                                            <td align="right" bgcolor="#FFFFFF" style="font-size:15px; color: #3FD1AA; font-weight: 850; padding: 0 6px 0 0;padding-right: 10px;width:100px;">
                                                {{item.price}}
                                                <img src="https://firebasestorage.googleapis.com/v0/b/ufs896vip/o/coupon%2Fchips.png?alt=media" width="36" height="36">
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td height="24"></td>
                </tr>
            </table>
            <div style="margin-top: 32px; margin-bottom: 10px; display: flex;">
              <Button
                style="display: flex; background-color: yellow; height: 50px; width: 100%; margin-left: 20px; margin-right: 20px; justify-content: center; align-items: center;"
                @click="shareFriend()"
                :disabled="isDisabled"
              >
                <span style="color: #000; font-size: 16px; font-weight: bold;"
                  >แนะนำเพื่อนทันที</span
                >
              </Button>
            </div>
            <div style="margin-bottom: 60px; display: flex;">
                <font style="font-size: 10px;">***เงื่อนไข หากพบว่ามีการเปิดยูสมาเพื่อรับแต่โบนัสอย่างเดียว ไม่มียอดการฝากเคลื่อนไหว ทางบริษัทขอตัดสิทธิ์การรับโบนัสทันที โดยไม่ต้องแจ้งให้ทราบ ***</font>
            </div>
        </md-app-content>
      </md-app>
    </div>
    <BottomMenu></BottomMenu>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import moment from "moment-timezone";
import router from "./../router";
import liffService from "@/services/liff";
const axios = require("axios").default;
export default {
  name: 'Home',
  components: {
    BottomMenu: require("./BottomMenu").default,
  },
  created() {
    // LIFF is already initialized by router guard
    this.loadUserData();
  },
  data() {
    return {
      menuVisible: false,
      pictureUrl: "",
      history: [],
      code:"",
      linkline:"https://lin.ee/9MgANfz",
      isDisabled:true,
      error:"",
    }
  },
  methods: {
    async shareFriend(){
      const result = await window.liff.shareTargetPicker([
        {
          "type": "flex",
          "altText": "UFA Easy888",
          "contents": {
              "type": "bubble",
              "hero": {
                "type": "image",
                "url": "https://line-ufaeasy2.web.app/images/line-header.jpg",
                "size": "full",
                "aspectRatio": "20:13",
                "aspectMode": "cover",
                "action": {
                  "type": "uri",
                  "uri": this.linkline
                }
              },
        "body": {
          "type": "box",
          "layout": "vertical",
          "spacing": "md",
          "contents": [
            {
              "type": "text",
              "text": "UFA Easy888",
              "wrap": true,
              "weight": "bold",
              "gravity": "center",
              "size": "xl"
            },
            {
              "type": "box",
              "layout": "baseline",
              "margin": "md",
              "contents": [
                {
                  "type": "icon",
                  "size": "sm",
                  "url": "https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png"
                },
                {
                  "type": "icon",
                  "size": "sm",
                  "url": "https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png"
                },
                {
                  "type": "icon",
                  "size": "sm",
                  "url": "https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png"
                },
                {
                  "type": "icon",
                  "size": "sm",
                  "url": "https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png"
                },
                {
                  "type": "icon",
                  "size": "sm",
                  "url": "https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png"
                },
                {
                  "type": "text",
                  "text": "5.0",
                  "size": "sm",
                  "color": "#999999",
                  "margin": "md",
                  "flex": 0
                }
              ]
            },
            {
              "type": "box",
              "layout": "vertical",
              "margin": "lg",
              "spacing": "sm",
              "contents": [
                {
                  "type": "box",
                  "layout": "baseline",
                  "spacing": "sm",
                  "contents": [
                    {
                      "type": "text",
                      "text": "🔥 UFA Easy888 [เว็บตรงไม่ผ่านเอเย่นต์]",
                      "wrap": true,
                      "size": "sm",
                      "color": "#666666",
                      "flex": 4
                    }
                  ]
                },
                {
                  "type": "box",
                  "layout": "baseline",
                  "spacing": "sm",
                  "contents": [
                    {
                      "type": "text",
                      "text": "🔥 เว็บกีฬาออนไลน์ ที่มาแรงที่สุดในตอนนี้",
                      "wrap": true,
                      "color": "#666666",
                      "size": "sm",
                      "flex": 4
                    }
                  ]
                },
                {
                  "type": "box",
                  "layout": "baseline",
                  "spacing": "sm",
                  "contents": [
                    {
                      "type": "text",
                      "text": "🔥 การเงินมั่นคงปลอดภัย 100 %",
                      "wrap": true,
                      "color": "#666666",
                      "size": "sm",
                      "flex": 4
                    }
                  ]
                },
                {
                  "type": "box",
                  "layout": "baseline",
                  "spacing": "sm",
                  "contents": [
                    {
                      "type": "text",
                      "text": "🔥 ดูแลการเงินด้วยแอดมิน ตลอด 24 ชั่วโมง",
                      "wrap": true,
                      "color": "#666666",
                      "size": "sm",
                      "flex": 4
                    }
                  ]
                },
                {
                  "type": "box",
                  "layout": "baseline",
                  "spacing": "sm",
                  "contents": [
                    {
                      "type": "text",
                      "text": "🔥 บอล หวย มวย คาสิโน เกมส์ ครบวงจร",
                      "wrap": true,
                      "color": "#666666",
                      "size": "sm",
                      "flex": 4
                    }
                  ]
                },
                {
                  "type": "box",
                  "layout": "baseline",
                  "spacing": "sm",
                  "contents": [
                    {
                      "type": "text",
                      "text": "🔥 เราใช้ระบบใหม่และดีที่สุดตอนนี้",
                      "wrap": true,
                      "color": "#666666",
                      "size": "sm",
                      "flex": 4
                    }
                  ]
                },
                {
                  "type": "box",
                  "layout": "baseline",
                  "spacing": "sm",
                  "contents": [
                    {
                      "type": "text",
                      "text": "🔥 ระบบแจ้งฝากและถอนได้รวดเร็วที่สุด",
                      "wrap": true,
                      "color": "#666666",
                      "size": "sm",
                      "flex": 4
                    }
                  ]
                },
                {
                  "type": "box",
                  "layout": "baseline",
                  "spacing": "sm",
                  "contents": [
                    {
                      "type": "text",
                      "text": "🔥 ระบบเราสามารถดู History ย้อนหลังได้",
                      "wrap": true,
                      "color": "#666666",
                      "size": "sm",
                      "flex": 4
                    }
                  ]
                },
                {
                  "type": "box",
                  "layout": "baseline",
                  "spacing": "sm",
                  "contents": [
                    {
                      "type": "text",
                      "text": "🔥 สามารถเข้าเล่นได้เพียงกดปุ่มเดียว",
                      "wrap": true,
                      "color": "#666666",
                      "size": "sm",
                      "flex": 4
                    }
                  ]
                },
                {
                  "type": "box",
                  "layout": "baseline",
                  "spacing": "sm",
                  "contents": [
                    {
                      "type": "text",
                      "text": "🔥 ฝาก - ถอน ภายใน 30วินาที",
                      "wrap": true,
                      "color": "#666666",
                      "size": "sm",
                      "flex": 4
                    }
                  ]
                }
              ]
            }
          ]
        },
        "footer": {
          "type": "box",
          "layout": "vertical",
          "contents": [
            {
              "type": "spacer",
              "size": "xs"
            },
            {
              "type": "button",
              "style": "primary",
              "color": "#a99955",
              "action": {
                "type": "uri",
                "label": "เพิ่มเพื่อน",
                "uri": this.linkline
              }
            }
          ]
        }
}
        }
      ]);
      if(result){
        alert('แชร์เพื่อนเรียบร้อยแล้ว ขอบคุณมากค่ะ');
        window.liff.closeWindow();
      }
    },
    async loadUserData() {
      // Get profile from centralized service (already fetched by router guard)
      const profile = liffService.profile;
      if (!profile) return;

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";
      if (this.userId) {
        this.linkline = 'https://liff.line.me/2006378234-72e9GVNa/register?userId='+this.userId;
        this.getDatatHistory(this.userId);
        const users = (
          await firebase
            .database()
            .ref(`/users`)
            .orderByChild("userId")
            .equalTo(this.userId)
            .once("value")
        ).val();
        if (users) {
          const queryString = decodeURIComponent(window.location.search);
          const params = new URLSearchParams(queryString);
          if(params.get("aid")){
            alert(params.get("aid"));
          }else{
            alert('wahaja');
          }
          //router.replace("/register");
        } else {
          let user = {};
          for (const x in users) {
            user = users[x];
          }
          this.code = user.code;
          if(user.code.substring(0, 8) === 'ufskq88t'){
            //this.linkline = 'https://lin.ee/Ca4Nyc1';
            this.linkline = 'https://liff.line.me/2006378234-72e9GVNa/registert?userId='+this.userId;
          }else if(user.code.substring(0, 8) === 'ufskq88r'){
            this.linkline = 'https://liff.line.me/2006378234-72e9GVNa/registerr?userId='+this.userId;
          }
          this.isDisabled = false;
        }
      }
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getDatatHistory(userId){
      firebase.firestore().collection('friends').where('userId','==',userId).get().then(async (querySnapshot) => {
          const history = [];
          const checkcode = [];
          querySnapshot.forEach((doc) => {
              checkcode.push(doc.data());
          });
          if(querySnapshot.size == 0){
              // this.first = 'XXXXXXXX';
              // this.second = 'XXXXXXXX';
              // this.third = 'XXXXXXXX';
              // history.push({image:'https://firebasestorage.googleapis.com/v0/b/ufs896vip/o/coupon%2Flogo2.png?alt=media',code:'XXXXXXXX',price:0});
              // history.push({image:'https://firebasestorage.googleapis.com/v0/b/ufs896vip/o/coupon%2Flogo2.png?alt=media',code:'XXXXXXXX',price:0
              // });
              this.error = 'คุณยังไม่มีเพื่อน ถ้าคุณได้แนะนำเพื่อนจริงโปรดแจ้งทางแอดมิน ขอบคุณค่ะ';
          }
          for(const x in checkcode){
            const user2 = (await firebase.database().ref(`/users`).orderByChild(`userId`).equalTo(checkcode[x].friendId).once('value')).val();
            const user = user2[Object.keys(user2)[0]];
            let price = 0;
            await firebase.firestore().collection('krungsri').where('userId','==',checkcode[x].friendId).where('createdate','>=',moment().tz("Asia/Bangkok").format('YYYY-MM-DD')+' 00:00:00').get().then((snapshot)=>{
              snapshot.forEach((doc) => {
                    price += Number(doc.data().qty.replace(/,/g, ''));
              });
            });
            if(price){
              price = Math.floor(Number((price*5)/100));
            }
            history.push({image:user.pictureUrl,code:user.code,price:this.numberWithCommas(Number(price).toFixed(2))});
          }
          this.history = history;
      });
    },
  }
}
</script>

<style lang="scss" scoped>
  .md-app {
    height: 500px;
    border: 1px solid rgba(#000, .12);
  }
  .md-toolbar.md-theme-default.md-primary {
     background-color: #000;
  }
  .md-content.md-theme-default {
    background-color: #000;
  }
   // Demo purposes only
  .md-drawer {
    width: 230px;
    max-width: calc(100vw - 125px);
  }
  .md-card.md-theme-default {
    background-color: #000;
    background-color: var(--md-theme-default-background, #000);
  }
</style>
<style>
.md-table-content {
    background-color: #000 !important;
    background-color: var(--md-theme-default-background, #000) !important;
 }
 .md-app-scroller {
   background-color: #000 !important;
 }
 .md-table .md-table-head-text,
.md-table .md-table-cell .md-table-cell-container {
  padding-right: 5;
  padding-left: 0;
}
.fontnew{
  font-size: 14px;
  box-sizing:border-box;
  -moz-box-sizing:border-box;
  -webkit-box-sizing:border-box;
  padding: 25px 5px 5px 5px;
}
</style>